import { type NoteEvent } from '../progression/index.js'
import { convertDuration } from './convert-duration.js'
import { type EasyScoreNoteString } from './simple-note.js'

export const noteEventString = (event: NoteEvent): EasyScoreNoteString => {
  const { octave = 4, note, duration } = event

  return `${note}${octave}/${convertDuration(duration)}`
}
